import { combineReducers } from 'redux';

import Supplier from './Supplier';
import Food from './Food';
import UnitHome from './UnitHome';
import ItinerarySupplierFood from './ItinerarySupplierFood';
import ItineraryFoodInvoice from './ItineraryFoodInvoice';

export default combineReducers({
  UnitHome,
  Supplier,
  Food,
  ItinerarySupplierFood,
  ItineraryFoodInvoice,
});
